import { CarrierProductionFileId } from '../reporting/carrier-production-raw-carrier-file.model';

export enum DownloadReportingImportSubmitFileRequestKeys {
  runId = 'runId',
  uploadActionId = 'uploadActionId',
  reportDate = 'reportDate',
  carrierFileId = 'carrierFileId',
}

export interface DownloadReportingImportSubmitFileRequest {
  [DownloadReportingImportSubmitFileRequestKeys.runId]?: string | null;
  [DownloadReportingImportSubmitFileRequestKeys.uploadActionId]?: string | null;
  [DownloadReportingImportSubmitFileRequestKeys.reportDate]?: string | null;
  [DownloadReportingImportSubmitFileRequestKeys.carrierFileId]?: CarrierProductionFileId | null;
}
